import React, { useState } from 'react';

import { ReactComponent as EyeDisabledIcon } from '@pkg/assets/icons/v2/eye-off.svg';
import { ReactComponent as EyeIcon } from '@pkg/assets/icons/v2/eye.svg';
import { Editor, Preview } from '@pkg/components';
import { baseRulesMdString } from '@pkg/components/Sections/Admin/Fantasy/Rules/base-rules-md-string';
import { Button } from '@pkg/components/Sections/Profile/Buttons';

import { ControlsSection, HeaderSection, MarkdownEditorWrapper, PageContentWrapper, Section } from './styles';

interface MarkdownEditorProps {
    onSave: (mdValue: string) => void;
    initialValue?: string;
    suggestInitial?: boolean;
    compact?: boolean;
    clearOnSave?: boolean;
    ctaCopy?: string;
}
export const MarkdownEditor = ({
    onSave,
    initialValue,
    compact = false,
    suggestInitial = false,
    clearOnSave = false,
    ctaCopy = 'Save',
}: MarkdownEditorProps) => {
    const [markdown, setMarkdown] = useState(initialValue || '');
    const [showEditor, setShowEditor] = useState(true);
    const [showPreview, setShowPreview] = useState(true);

    function handleSave() {
        onSave(markdown);
        if (clearOnSave) {
            setMarkdown('');
        }
    }

    return (
        <PageContentWrapper $compact={compact}>
            <HeaderSection>
                <Button color="clear" size="small" onClick={() => setShowEditor((c) => !c)}>
                    {showEditor ? <EyeDisabledIcon /> : <EyeIcon />} Editor
                </Button>
                <Button color="clear" size="small" onClick={() => setShowPreview((c) => !c)}>
                    Preview {showPreview ? <EyeDisabledIcon /> : <EyeIcon />}
                </Button>
            </HeaderSection>
            <MarkdownEditorWrapper>
                <Section $hidden={!showEditor}>
                    <Editor markdownValue={markdown} onMarkdownChange={(md) => setMarkdown(md)} />
                </Section>
                <Section $hidden={!showPreview}>
                    <Preview markdown={markdown} />
                </Section>
            </MarkdownEditorWrapper>
            <ControlsSection>
                <Button size="small" color="transparent" onClick={() => setMarkdown('')}>
                    Clear
                </Button>
                {!initialValue && suggestInitial && (
                    <Button size="small" color="translucent" onClick={() => setMarkdown(baseRulesMdString)}>
                        Use default rules
                    </Button>
                )}
                <Button size="small" onClick={handleSave} disabled={!markdown?.length}>
                    {ctaCopy}
                </Button>
            </ControlsSection>
        </PageContentWrapper>
    );
};
